import * as actions from './actions'
import * as getters from './getters'
import * as mutations from './mutations'

export default {
  state: {
    main_email: '',
    cc_email_1: '',
    cc_email_2: '',
    cc_email_3: '',
    cc_email_4: '',
    link_manual: {
      th: process.env.MANUAL_URL_TH + '#email-shop',
      en: process.env.MANUAL_URL_EN + '#email-shop',
      vi: process.env.MANUAL_URL_VI + '#email-shop'
    }
  },
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/cc_emails/index.js